import React from 'react'
import styled from '@emotion/styled'
import { object, string } from 'prop-types'

// Import Components
import { AdvertisingDisclosure } from '../TopFiveQT/AdvertisingDisclosure'
import BuyingGuideSection from './BuyingGuideSection'
import Footer from './Footer'
import CallToActionSection from './CallToActionSection'
import Header from './Header'
import { PageWrapper } from '@jelly/components'
import StatsBar from './StatsBar'
import TopBrands from './TopBrands'
import { array } from 'prop-types'

const Wrapper = styled.div`
	align-items: center;
	display: flex;
	flex-direction: column;
	width: 100%;
`
const CallToActionTopSection = styled(CallToActionSection)`
	margin-top: 0;

	${({ theme }) => theme.MQ.M} {
		margin-top: 0;
	}
`

LeaveBehindPage.propTypes = {
	ctaBottomHeader: string,
	ctaBottomQuestion: string,
	ctaTopHeader: string,
	ctaTopQuestion: string,
	ctaTopHero: string,
	logos: array,
	meta: object.isRequired,
	sectionBuyingGuides: array,
	sectionTopBrandTitle: string,
	stats: array,
}
export function LeaveBehindPage({
	ctaBottomHeader,
	ctaBottomQuestion,
	ctaTopHeader,
	ctaTopQuestion,
	ctaTopHero,
	logos,
	meta,
	sectionBuyingGuides,
	sectionTopBrandTitle,
	stats,
}) {
	return (
		<PageWrapper meta={meta}>
			<Wrapper>
				<AdvertisingDisclosure />
				<Header />
				<CallToActionTopSection backgroundImg={ctaTopHero} title={ctaTopHeader} question={ctaTopQuestion} />
				<StatsBar stats={stats} />
				<TopBrands logos={logos} sectionTopBrandTitle={sectionTopBrandTitle} />
				<BuyingGuideSection sections={sectionBuyingGuides} />
				<CallToActionSection title={ctaBottomHeader} question={ctaBottomQuestion} />
				<Footer />
			</Wrapper>
		</PageWrapper>
	)
}
